/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Dead_Letter_QueuesInputs */

const en_svchip_dead_letter_queues = /** @type {(inputs: Svchip_Dead_Letter_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dead-letter queues`)
};

const ar_svchip_dead_letter_queues = /** @type {(inputs: Svchip_Dead_Letter_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قوائم الرسائل الميتة`)
};

const bn_svchip_dead_letter_queues = /** @type {(inputs: Svchip_Dead_Letter_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেড-লেটার কিউ`)
};

const de_svchip_dead_letter_queues = /** @type {(inputs: Svchip_Dead_Letter_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warteschlangen für unzustellbare Nachrichten`)
};

const es_svchip_dead_letter_queues = /** @type {(inputs: Svchip_Dead_Letter_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colas de mensajes fallidos`)
};

const fr_svchip_dead_letter_queues = /** @type {(inputs: Svchip_Dead_Letter_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files d'attente de lettres mortes`)
};

const pt_svchip_dead_letter_queues = /** @type {(inputs: Svchip_Dead_Letter_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filas de mensagens mortas`)
};

const zh_svchip_dead_letter_queues = /** @type {(inputs: Svchip_Dead_Letter_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`死信队列`)
};

const tr_svchip_dead_letter_queues = /** @type {(inputs: Svchip_Dead_Letter_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teslim edilmeyen mektup kuyrukları`)
};

const ru_svchip_dead_letter_queues = /** @type {(inputs: Svchip_Dead_Letter_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очереди недоставленных сообщений`)
};

const pl_svchip_dead_letter_queues = /** @type {(inputs: Svchip_Dead_Letter_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolejki niedostarczonych wiadomości`)
};

/**
* | output |
* | --- |
* | "Dead-letter queues" |
*
* @param {Svchip_Dead_Letter_QueuesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_dead_letter_queues = /** @type {((inputs?: Svchip_Dead_Letter_QueuesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Dead_Letter_QueuesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_dead_letter_queues(inputs)
	if (locale === "bn") return bn_svchip_dead_letter_queues(inputs)
	if (locale === "de") return de_svchip_dead_letter_queues(inputs)
	if (locale === "es") return es_svchip_dead_letter_queues(inputs)
	if (locale === "fr") return fr_svchip_dead_letter_queues(inputs)
	if (locale === "pt") return pt_svchip_dead_letter_queues(inputs)
	if (locale === "zh") return zh_svchip_dead_letter_queues(inputs)
	if (locale === "tr") return tr_svchip_dead_letter_queues(inputs)
	if (locale === "ru") return ru_svchip_dead_letter_queues(inputs)
	if (locale === "pl") return pl_svchip_dead_letter_queues(inputs)
	return en_svchip_dead_letter_queues(inputs)
});